import {
  FETCH_PROTECTION_QUOTE_REQUEST,
  FETCH_PROTECTION_QUOTE_SUCCESS,
  FETCH_PROTECTION_QUOTE_FAILURE,
} from "../actions/types";

const initialState = {
  quote: null,
  loading: false,
  error: null,
};

export default function protectionReducer(
  state = initialState,
  action
) {
  switch (action.type) {
    case FETCH_PROTECTION_QUOTE_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case FETCH_PROTECTION_QUOTE_SUCCESS:
      return {
        ...state,
        loading: false,
        quote: action.payload,
      };

    case FETCH_PROTECTION_QUOTE_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    default:
      return state;
  }
}